var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForumDetailsHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.818,
    height: 21.94,
    viewBox: "0 0 22.818 21.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-heart-empty",
    "data-name": "Icon ionic-ios-heart-empty",
    d: "M20.049,3.938h-.055A6.241,6.241,0,0,0,14.784,6.79,6.241,6.241,0,0,0,9.573,3.938H9.518a6.2,6.2,0,0,0-6.143,6.2A13.351,13.351,0,0,0,6,17.414a45.946,45.946,0,0,0,8.787,8.463,45.946,45.946,0,0,0,8.787-8.463,13.352,13.352,0,0,0,2.622-7.279A6.2,6.2,0,0,0,20.049,3.938Zm2.282,12.572a42.069,42.069,0,0,1-7.547,7.438A42.132,42.132,0,0,1,7.236,16.5a11.833,11.833,0,0,1-2.326-6.368A4.654,4.654,0,0,1,9.529,5.479h.049a4.6,4.6,0,0,1,2.254.592A4.793,4.793,0,0,1,13.5,7.634a1.541,1.541,0,0,0,2.578,0,4.841,4.841,0,0,1,1.667-1.563A4.6,4.6,0,0,1,20,5.479h.049a4.654,4.654,0,0,1,4.618,4.657A11.983,11.983,0,0,1,22.331,16.509Z",
    transform: "translate(-3.375 -3.938)",
    fill: "#40eefe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumDetailsHeart);
export default __webpack_public_path__ + "static/media/forum-details-heart.35d534ed535820f521c7a3bea9252065.svg";
export { ForwardRef as ReactComponent };